export const ACTION_SET_TOGGLE_ANALYSIS_RESULT = 'SET_TOGGLE_ANALYSIS_RESULT';

export const setToggleAnalysisResult = (state) => {
    return {
        type: ACTION_SET_TOGGLE_ANALYSIS_RESULT,
        payload: state
    }
}